import React, { forwardRef } from "react";

import { Icon } from "../components/icon";

const UserIcon = forwardRef<any, any>((props, ref) => {
  const width = "19";
  const height = "19";
  const viewBox = `0 0 ${width} ${height}`;

  return (
    <Icon width={width} height={height} viewBox={viewBox} {...props} ref={ref}>
      <svg fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.5 13.9755C14.5002 13.8147 14.4616 13.6561 14.3874 13.5134C14.3132 13.3706 14.2057 13.2479 14.074 13.1555C12.2699 11.9872 10.1474 11.4085 8 11.4995C5.85262 11.4085 3.73005 11.9872 1.926 13.1555C1.79427 13.2479 1.68677 13.3706 1.61261 13.5134C1.53844 13.6561 1.49982 13.8147 1.5 13.9755V16.4995H14.5V13.9755Z"
          stroke={props.stroke || "#676767"}
          strokeWidth={props.strokeWidth || 2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 8.5C9.933 8.5 11.5 6.933 11.5 5C11.5 3.067 9.933 1.5 8 1.5C6.067 1.5 4.5 3.067 4.5 5C4.5 6.933 6.067 8.5 8 8.5Z"
          stroke={props.stroke || "#676767"}
          strokeWidth={props.strokeWidth || 2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
});

export { UserIcon };
